import React, {useState} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { externalPaymentMethods } from '../../../Data/Payments';
import Icon from '../../Icons/Icon';

const fallbackValue = {};

const validators = [(val) => {
    if (!val.addExternalPayment) {
        return [true, null];
    }
    if (!val.paymentMethod || val.paymentMethod === '') {
        return [false, 'Please select a payment method'];
    }
    if (!val.amount) {
        return [false, 'Please enter a payment amount'];
    }
    return [true, null];
}];

const ExternalPayments = ({label, name, help, onChange, disabled}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;

    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [externalPaymentsEnabled, setExternalPaymentsEnabled] = useState(false);

    useFieldPanelHelper(name, value, isValid);

    const toggleEnabled = (on) => {
        setExternalPaymentsEnabled(on)
        handleChange(on ? {...(value ?? {}), addExternalPayment: true} : {addExternalPayment: false});
    }

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const changeField = (field, val) => {
        handleChange({...(value ?? {}), [field]: val});
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <Toggle enabled={externalPaymentsEnabled}
            onChange={toggleEnabled}
            label={'Add external payment'}
            disabled={isDisabled}
            hideFocusRing
        />

        {externalPaymentsEnabled && <>
            <p className="mt-2">
                <label htmlFor="paymentMethod" className="inline-block w-full text-xs font-medium text-gray-600 text-left">Payment method</label>
                <select
                    id="paymentMethod"
                    name="paymentMethod"
                    className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                    value={value?.paymentMethod}
                    onChange={e => changeField('paymentMethod', e.target.value)}
                    disabled={isDisabled}
                >
                    <option value="">Select a payment method</option>
                    {externalPaymentMethods.map(method => <option key={method.value} value={method.value}>{method.label}</option>)}
                </select>
            </p>

            <div className="mt-2">
                <label htmlFor="amount" className="inline-block w-full text-xs font-medium text-gray-600 text-left">
                    Payment amount
                </label>
                <div className="relative flex flex-row">
                    <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1 fill-gray-400">
                        <Icon icon="SterlingSign" size="0.5x" inline />
                    </div>

                    <input className="ml-1 block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                        type="number"
                        id="amount"
                        value={value.amount ? (value.amount/100).toFixed(2) : ''}
                        onChange={e => changeField('amount', parseInt(e.target.value.replace(/[^0-9]*/g, '')))}
                        placeholder={"0.00"}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        </>}

    </CommonFieldWrapper>
}

export default ExternalPayments;
